module.exports = __webpack_public_path__ + "c303f6f61f4e56ddfc1bcd91dae902a1.webp";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/trailer_preview-420.webp
// module id = 558
// module chunks = 0